import axios from 'axios';
import { api } from '../config';
import { getAuthToken } from '../auth/tokenvalidation';

const authHeaders = () => ({
  Authorization: `Bearer ${getAuthToken()}`,
});

export const getTenderAnnouncements = params =>
  axios.get(`${api.API_URL}/tender-announcement`, {
    params,
    headers: authHeaders(),
  });

export const getTenderAnnouncementById = id =>
  axios.get(`${api.API_URL}/tender-announcement/${id}`, {
    headers: authHeaders(),
  });

export const createTenderAnnouncement = payload =>
  axios.post(`${api.API_URL}/tender-announcement`, payload, {
    headers: authHeaders(),
  });

export const updateTenderAnnouncement = (id, payload) =>
  axios.put(`${api.API_URL}/tender-announcement/${id}`, payload, {
    headers: authHeaders(),
  });

export const deleteTenderAnnouncement = id =>
  axios.delete(`${api.API_URL}/tender-announcement/${id}`, {
    headers: authHeaders(),
  });

// mode: 'Unpublish' | 'PublishNow' | 'Schedule'.
// scheduledPublishDate wajib dan harus di masa depan hanya bila mode = 'Schedule'.
export const setTenderAnnouncementPublish = (
  id,
  mode,
  scheduledPublishDate = null
) =>
  axios.put(
    `${api.API_URL}/tender-announcement/${id}/publish`,
    { mode, scheduledPublishDate },
    { headers: authHeaders() }
  );

// Procurement yang belum punya pengumuman, untuk mode "From Procurement".
export const getAvailableProcurements = params =>
  axios.get(`${api.API_URL}/tender-announcement/available-procurement`, {
    params,
    headers: authHeaders(),
  });

export const uploadTenderAnnouncementDocument = (id, file, displayOrder) => {
  const formData = new FormData();
  formData.append('File', file);
  if (displayOrder !== undefined && displayOrder !== null) {
    formData.append('DisplayOrder', displayOrder);
  }
  return axios.post(
    `${api.API_URL}/tender-announcement/${id}/document`,
    formData,
    {
      headers: {
        ...authHeaders(),
        'Content-Type': 'multipart/form-data',
      },
    }
  );
};

export const updateTenderAnnouncementDocument = (documentId, payload) =>
  axios.put(
    `${api.API_URL}/tender-announcement/document/${documentId}`,
    payload,
    {
      headers: authHeaders(),
    }
  );

export const deleteTenderAnnouncementDocument = documentId =>
  axios.delete(`${api.API_URL}/tender-announcement/document/${documentId}`, {
    headers: authHeaders(),
  });

export const getTenderAnnouncementDocumentViewUrl = documentId =>
  axios.get(
    `${api.API_URL}/tender-announcement/document/${documentId}/view-url`,
    { headers: authHeaders() }
  );
